import React from 'react';
import PropTypes from 'prop-types';
import styles from './PFSStaffMember.module.css';
import placeholderImage from './empty.png';
import LoadingImage from '../LoadingImage/LoadingImage';

const PFSStaffMember = ({ id, image, name, title }) => {
  return (
    <div
      id={id ?? ''}
      className={styles.PFSStaffMember}
      data-testid='PFSStaffMember'
    >
      <center>
        <div className={styles.ImageContainer}>
          <LoadingImage
            placeholderImage={placeholderImage}
            image={image}
            styleclass={styles.PFSStaffMemberImage}
            altText='Staff Member'
          />
        </div>
        <p data-testid='PFSStaffMemberName'>{name}</p>
        <p data-testid='PFSStaffMemberTitle' className={styles.PersonTitle}>
          {title}
        </p>
      </center>
    </div>
  );
};

PFSStaffMember.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  id: PropTypes.string,
};

export default PFSStaffMember;
